import { Component, Input, OnInit } from '@angular/core';
import { PfandrechtMasterDetailEntryMeta } from '../../../../core/gb-api';
import { TranslatePipe } from '@ngx-translate/core';
import { KompaktGrundstueckComponent } from '../../../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { HistoryDirective } from '../../../../shared/directives/history.directive';
import { KompaktPfandrechtBelastungComponent } from '../../../../shared/kompaktdarstellung/pfandrecht-belastung/kompakt-pfandrecht-belastung.component';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { RechtsgrundComponent } from '../../../../shared/kompaktdarstellung/rechtsgrund/rechtsgrund.component';
import { NgTemplateOutlet } from '@angular/common';
import { OrderByGrundstuecknummerPipe } from '../../../../shared/pipes/order/order-by-grundstuecknummer.pipe';

@Component({
  selector: 'cap-pfandrecht-belastungen',
  templateUrl: './pfandrecht-belastungen.component.html',
  styleUrls: ['./pfandrecht-belastungen.component.scss'],
  imports: [
    TranslatePipe,
    KompaktGrundstueckComponent,
    HistoryDirective,
    KompaktPfandrechtBelastungComponent,
    KompaktTimepointComponent,
    RechtsgrundComponent,
    NgTemplateOutlet,
    OrderByGrundstuecknummerPipe
  ]
})
export class PfandrechtBelastungenComponent implements OnInit {
  @Input()
  recht: PfandrechtMasterDetailEntryMeta;

  constructor() {}

  ngOnInit() {}
}
